import React from 'react';
import { Package } from 'lucide-react';

const OfferSnapshot = ({ offerSnapshot, onOfferChange }) => {
  const handleChange = (field, value) => {
    onOfferChange({
      ...offerSnapshot,
      [field]: value
    });
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center gap-2 mb-4">
        <Package className="w-5 h-5 text-primary-600" />
        <h3 className="text-lg font-semibold text-gray-900">
          📦 Optional: What Are You Selling?
        </h3>
      </div>
      
      <p className="text-sm text-gray-600 mb-4">
        Help us create better CTAs by telling us about your product or offer. This makes the email feel more personal and relevant.
      </p>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Product/Offer Name
          </label>
          <input
            type="text"
            value={offerSnapshot.offerName}
            onChange={(e) => handleChange('offerName', e.target.value)}
            placeholder="e.g., Analog Action, Weekly Planner, Course"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Brief Description
          </label>
          <textarea
            value={offerSnapshot.offerDescription}
            onChange={(e) => handleChange('offerDescription', e.target.value)}
            placeholder="e.g., A weekly planning system to avoid burnout and stay focused"
            rows="2"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Price
            </label>
            <input
              type="text"
              value={offerSnapshot.offerPrice}
              onChange={(e) => handleChange('offerPrice', e.target.value)}
              placeholder="e.g., $9, Free, Starts at $97"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Link (Optional)
            </label>
            <input
              type="url"
              value={offerSnapshot.offerLink}
              onChange={(e) => handleChange('offerLink', e.target.value)}
              placeholder="https://..."
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>
        </div>
      </div>

      <div className="mt-4 p-3 bg-blue-50 rounded-md">
        <p className="text-xs text-blue-700">
          💡 <strong>Pro tip:</strong> This helps us create CTAs like "That's why I use [Product Name]" instead of generic "check it out" language.
        </p>
      </div>
    </div>
  );
};

export default OfferSnapshot; 